<template>
<div class="z-main">
	<header class="z-header">
		<div><router-link to="/my"><img src="../../assets/sysbars/left.png" /></router-link></div>
		<div>发布记录</div>
		<div></div>
	</header>
	<div class="z-body z-body-bottom0 z-body-noscroll">
		<!-- 查询 -->
		<div class="z-form-search" style="border-bottom:1px solid #2C2E33;">
			<div>
				<v-menu 
					ref="menu" 
					:close-on-content-click="false" 
					v-model="menu" 
					:nudge-right="-20" 
					:nudge-top="40" 
					lazy 
					transition="scale-transition" 
					offset-y 
					full-width
				>
					<v-text-field 
						style="margin: 0px;" 
						slot="activator" 
						v-model="dateFormatted" 
						persistent-hint 
						prepend-icon="event">
					</v-text-field>
					<v-date-picker 
						style="background-color: #3D3D3D" 
						v-model="date" 
						no-title 
						@input="menu = false">
					</v-date-picker>
				</v-menu>
			</div>
			<div>
				&nbsp;至&nbsp;
			</div>
			<div>
				<v-menu 
					ref="menu2" 
					:close-on-content-click="false" 
					v-model="menu2" 
					:nudge-right="-20" 
					:nudge-top="40" 
					lazy 
					transition="scale-transition" 
					offset-y 
					full-width
				>
					<v-text-field 
						style="margin: 0px;" 
						slot="activator" 
						v-model="dateFormatted2" 
						persistent-hint 
						prepend-icon="event" >
					</v-text-field>
					<v-date-picker 
						style="background-color: #3D3D3D;" 
						v-model="date2" 
						no-title 
						@input="menu2 = false">
					</v-date-picker>
				</v-menu>
			</div>
			<div>
				<div class="z-form-search-btn" @click="downCallback">查询</div>
			</div>
		</div>
		<!-- 数据 -->
		<div ref="mescroll" id="z-publishSellRecord-mescroll" class="z-padding10 z-calc115 mescroll">
			<div>
				<div v-for="(item,index) in data" class="z-publishRecord-item">
					<div class="z-publishRecord-sell">
						<div>
							<div>
								出售：{{item.amount}}
								&nbsp;&nbsp;
								<span :style="{color:colors[item.state]}" v-text="item.state_text"></span>
							</div>
							<div class="z-fc-1" style="margin:8px 0px;">发布时间：{{item.ctime}}</div>
							<div v-show="item.state==1">
								<span class="z-form-search-btn z-btn-inline" style="background:#4CAF50;margin-left:0px;" @click="sellStop(item.id)">终止</span>
							</div>
						</div>
						<div v-if="item.buylist && item.buylist.length>0">
							<img src="../../assets/my/publish/to-up.png" @click="show=-1" v-show="show==index"/>
							<img src="../../assets/my/publish/to-down.png" @click="show=index" v-show="show!==index" />
						</div>
					</div>
					<div class="z-publishRecord-buy" v-if="item.buylist && item.buylist.length>0 && show==index">
						<div class="z-publishRecord-buy-item" v-for="(item2,index2) in item.buylist">
							<div>
								<div>交易账号：{{item2.trade_account?item2.trade_account:'无'}}</div>
								<div class="z-fc-1">交易数量：{{item2.amount}}</div>
								<div class="z-fc-1">银行转账金额：&yen;{{item2.rmb}}</div>
								<div class="z-fc-1">交易时间：{{item2.ctime}}</div>
								<div class="z-fc-1" v-if="item2.files.length>0">
									<a v-for="(item3,index) in item2.files" :href="item3" >
										<img class="z-sell-buy-img"
										:src="item3"/>
									</a>
								</div>
							</div>
							<div class="z-btns-block" v-if="item2.state==1">
								<span class="z-form-search-btn z-btn-inline" style="background:#1976D2;" @click="buyUpdate(item2.id,2)">确认收款</span>
								<span class="z-form-search-btn z-btn-inline" style="background:#FF5252;" @click="buyUpdate(item2.id,3)">未收到款</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

	</div>
</div>
</template>

<script>
export default {
	name: 'publishRecord',
	data() {
		return {
			colors:['#4CAF50','#4CAF50','#4CAF50','#6C6C6C','#6C6C6C'],
			date: new Date().toISOString().substr(0, 10),
			dateFormatted: new Date().toISOString().substr(0, 10),
			menu: false,
			date2: new Date().toISOString().substr(0, 10),
			dateFormatted2: new Date().toISOString().substr(0, 10),
			menu2: false,
			show:-1,
			data:[],
			//上拉下拉
			mescroll: null
		}
	},
	watch: {
		date (val) {
			this.dateFormatted = this.date
		},
		date2 (val) {
			this.dateFormatted2 = this.date2
		}
	},
	mounted() {
		this.mescrollInit()
	},
	methods: {
		// mescroll组件初始化的回调,可获取到mescroll对象
		mescrollInit () {
			let _this = this;
			_this.mescroll = new MeScroll("z-publishSellRecord-mescroll",{
				up:{
					callback: _this.upCallback
				}
			})
		},
		// 下拉回调 、 查询回调
		downCallback(){
			let _this = this
			_this.getList(1,function (rs) {
			})
		},
		// 上拉回调 page = {num:1, size:10}; num:当前页 ,默认从1开始; size:每页数据条数,默认10
		upCallback (page, mescroll) {
			let _this = this
			_this.getList(page.num,function (rs) {

			})
		},
		getList(pageIndex,callback){
			let _this = this
			// 联网请求
			this.get('api/Agora/myRecord', {
				stime:this.date,
				etime:this.date2,
				page: pageIndex, // 页码
				limit: 15 // 每页长度
			}).then((rs) => {
				let arr = rs.data.data
				// 如果是第一页需手动置空列表
				if (pageIndex === 1) {
					_this.data = []
				}

				if (arr.length == 0) 
				{
					_this.$store.commit('layer','暂无数据')
				}
				else {
					// 把请求到的数据添加到列表
					_this.data = _this.data.concat(arr)
				}
				callback && callback(rs)
				// 数据渲染成功后,隐藏下拉刷新的状态
				_this.$nextTick(() => {
					_this.mescroll.endSuccess(arr.length)
				})
				
			}).catch((e) => {
				// 联网失败的回调,隐藏下拉刷新和上拉加载的状态;
				_this.mescroll.endErr()
			})
		},
		//更新交易状态，state：1:未收到；2:已收到款；
		buyUpdate(id,state){
			this.post('api/Agora/changeState',{state:state,id:id}).then((rs)=>{
				this.$store.commit('layer',rs.msg)
				if (rs.code==0) {
					this.downCallback()
				}
			})
		},
		//中止
    	sellStop(id){
    		this.post('api/Agora/stop',{id:id}).then((rs)=>{
				this.$store.commit('layer',rs.msg)
				if (rs.code==0) {
					this.downCallback()
				}
			})
    	}
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.z-publishRecord-item {
	display: -webkit-flex; /* Safari */
	display: flex;
	justify-content:center;
	flex-direction: column;
	align-items:center;
	margin-bottom: 10px;
}
.z-publishRecord-sell,
.z-publishRecord-buy {
	display: -webkit-flex; /* Safari */
	display: flex;
	width: 100%;
	justify-content:space-between;
	padding: 10px;
	align-items:center;
}
.z-publishRecord-sell {
	background: #252830;
	border:1px solid #3E3E40;
	border-radius:5px 5px 0px 0px;
}
.z-publishRecord-sell img {
	width: 14px;
	height: 14px;
}
.z-publishRecord-buy {
	flex-direction: column;
	border:1px solid #3E3E40;
	border-top: none;
	border-radius: 0px 0px 5px 5px;
}
.z-publishRecord-buy-item {
	display: -webkit-flex; /* Safari */
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	background: #252830;
	margin-bottom: 10px;
	padding: 10px;
	width: 100%;
}
.z-fc-1 {
	font-size: 14px;
	color: #6C6C6C;
	padding: 5px 0px;
}
.z-btn-inline {
	font-size: 10px;
	padding: 5px 10px;
	width: auto;
	margin-bottom: 10px;
}
.z-btns-block {
	display: -webkit-flex; /* Safari */
	display: flex;
	flex-direction: column;
	align-items:center;
}
.z-sell-buy-img{
	width: 80px;
	height: 80px;
}
</style>



// WEBPACK FOOTER //
// src/pages/my/publishSellRecord.vue